import PropTypes from 'prop-types';
import React, { Component } from 'react';

const styles = {
  container: {
    margin: 10,
    textAlign: 'justify',
    fontFamily: 'Raleway',
  },
  link: {
    textDecoration: 'underline',
  },
  list: {
    fontWeight: '600',
    marginBottom: 20,
  },
  listItem: {
    marginBottom: 20,
  },
};

// eslint-disable-next-line react/prefer-stateless-function
export default class CodeOfConduct extends Component {
  static propTypes = {
    style: PropTypes.object,
  };

  render() {
    const { style } = this.props;
    const legalEmail = <a style={styles.link} href='mailto:legal@ripplestreet.com'>legal@ripplestreet.com</a>;
    return (
      <div style={styles.container}>
        <div style={style}>
          <ol style={styles.list}>
            <li style={styles.listItem}>
              <p>
                <strong>Disclosure</strong>
              </p>
              <p>
                When you post comments or content about a company, its products or services, you should clearly and
                conspicuously disclose the nature of your relationship. Tell people that you&apos;re a Ripple Street
                House Party host or Chatterbox participant and you&apos;ve received a free Party or Chat Pack with some
                great things to try.
              </p>
            </li>
            <li style={styles.listItem}>
              <p>
                <strong>Trademarks and Intellectual Property</strong>
              </p>
              <p>
                Any trademarks, logos, materials and other proprietary information that Ripple Street may provide to
                you, including those of its clients, or which you have access to, may not be used without the prior
                written permission of Ripple Street or its Client and can only be used in accordance with provided
                guidelines. If you have any doubt as to what is proprietary, contact Ripple Street at {legalEmail} or do
                not post the information.
              </p>
            </li>
            <li style={styles.listItem}>
              <p>
                <strong>You could be liable.</strong>
              </p>
              <p>
                The statements you make are at your own risk. Outside parties can pursue legal action against you for
                statements or postings that you make so be careful.
              </p>
            </li>
            <li style={styles.listItem}>
              <p>
                <strong>General Guidelines.</strong>
              </p>
              <ul style={styles.list}>
                <li>
                  Do Not Reveal Non-Public Information. For example, don&apos;t share your phone number, address or
                  social security number.
                </li>
                <li>
                  Protect Yourself &ndash; Be careful about what you write and remember it will be stored and
                  retrievable.
                </li>
                <li>
                  Be Respectful. Do not be offensive or write with intent to tell lies or spread rumors. Do not use
                  ethnic or racial slurs, insults, obscenities or offensive language. Please show proper consideration
                  for the privacy of others and proper judgment regarding topics that may be considered objectionable or
                  inflammatory such as religion or politics.
                </li>
                <li>
                  Be Accurate and Constructive. Your comments may impact Ripple Street and our clients. Your postings,
                  views and comments should be expressions of your actual experience and beliefs.
                </li>
                <li>
                  Safety. Do not post any comments or content that in any way promotes unsafe activities, illegal
                  activities or products that could lead to an unsafe situation.
                </li>
                <li>
                  Remember Your Audience. If you&apos;re discussing an adult-focused event, please don&apos;t engage a
                  younger audience or allow minors to post comments.
                </li>
              </ul>
            </li>
          </ol>
        </div>
      </div>
    );
  }
}
